import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule, BreadcrumbService } from 'xng-breadcrumb';
import {
  breadcrumbNames,
  DashboardRoute,
} from '../../utility/constants';
import { BreadcrumbNavigationService } from '../../services/breadcrumb-navigation.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [BreadcrumbModule, CommonModule, RouterModule],
  providers: [BreadcrumbService],
  templateUrl: './app-breadcrumb.component.html',
  styleUrl: './app-breadcrumb.component.scss',
})
export class AppBreadcrumbComponent {
  readonly fromDashboard$ = this.breadcrumbNav.fromDashboard$;
  readonly dashboardLabel = breadcrumbNames.Dashboard;
  readonly dashboardRoute = DashboardRoute.root;

  readonly dashboardQueryParams$ = this.breadcrumbNav.returnDashboardQueryParams$;

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly breadcrumbNav: BreadcrumbNavigationService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.set('@home', breadcrumbNames.Home);
    this.breadcrumbService.set('@dashboard', breadcrumbNames.Dashboard);
    this.breadcrumbService.set('@hawb', 'Home');
    this.breadcrumbService.set('@bag', 'Home');
    this.breadcrumbService.set('@manifest', 'Home');
    this.breadcrumbService.set('@mawb', 'Home');
    this.breadcrumbService.set('@bag-information', 'Bags');
    this.breadcrumbService.set('@hawb-information', 'Shipment');
    this.breadcrumbService.set('@manifest-information', 'Manifest');
    this.breadcrumbService.set('@commodity-information', 'Commodity');
    this.breadcrumbService.set('@mawb-information', 'MAWB');
    this.breadcrumbService.set('@sm-dashboard', 'Home');
    this.breadcrumbService.set('@flight-information', 'Flight');
    this.breadcrumbService.set('@agent-summary', 'Agent');
    this.breadcrumbService.set('@agent-information', 'Agent Information');
    this.breadcrumbService.set(
      '@hawb-advanced-search',
      breadcrumbNames.Shipment
    );
    this.breadcrumbService.set('@bag-advanced-search', breadcrumbNames.Bag);
    this.breadcrumbService.set(
      '@manifest-advanced-search',
      breadcrumbNames.Manifest
    );
    this.breadcrumbService.set('@account-summary', breadcrumbNames.Account);
    this.breadcrumbService.set('@mawb-advanced-search', breadcrumbNames.MAWB);
    this.breadcrumbService.set(
      '@account-information',
      breadcrumbNames.AccountInfo
    );
    this.breadcrumbService.set('@status-codes', breadcrumbNames.StatusCodes);
    this.breadcrumbService.set(
      '@roles-and-permissions',
      breadcrumbNames.RolesAndPermissions
    );
    this.breadcrumbService.set(
      '@fullman-upload',
      breadcrumbNames.fullmanUpload
    );
    this.breadcrumbService.set(
      '@user-management',
      breadcrumbNames.UserManagement
    );
    this.breadcrumbService.set(
      '@user-information',
      breadcrumbNames.UserInformation
    );
    this.breadcrumbService.set('@user-profile', breadcrumbNames.UserProfile);
    this.breadcrumbService.set(
      '@roles-and-permissions-information',
      breadcrumbNames.RolesAndPermissionsInfo
    );
    this.breadcrumbService.set('@airports', breadcrumbNames.Airports);
    this.breadcrumbService.set(
      '@airport-information',
      breadcrumbNames.AirportInfo
    );
    this.breadcrumbService.set('@number-ranges', breadcrumbNames.NumberRanges);
    this.breadcrumbService.set('@airlines', breadcrumbNames.Airlines);
    this.breadcrumbService.set(
      '@airline-information',
      breadcrumbNames.AirlineInfo
    );
    this.breadcrumbService.set('@agent-types', breadcrumbNames.AgentTypes);
    this.breadcrumbService.set('@hs-codes', breadcrumbNames.HsCodes);
    this.breadcrumbService.set(
      '@hs-code-information',
      breadcrumbNames.HsCodeInfo
    );
    this.breadcrumbService.set('@facilities', breadcrumbNames.Facilities);
    this.breadcrumbService.set(
      '@facility-information',
      breadcrumbNames.FacilityInfo
    );
    this.breadcrumbService.set('@service-types', breadcrumbNames.ServiceTypes);
    this.breadcrumbService.set(
      '@accounts-payable',
      breadcrumbNames.AccountPayable
    );
    this.breadcrumbService.set(
      '@accounts-receivable',
      breadcrumbNames.AccountReceivable
    );
    this.breadcrumbService.set(
      '@service-type-groups',
      breadcrumbNames.ServiceTypeGroups
    );
    this.breadcrumbService.set(
      '@clearance-types',
      breadcrumbNames.ClearanceTypes
    );
    this.breadcrumbService.set(
      '@ibc-charge-codes',
      breadcrumbNames.IbcChargeCodes
    );
    this.breadcrumbService.set('@delivery-zone', breadcrumbNames.deliveryZone);
    this.breadcrumbService.set(
      '@delivery-zone-information',
      breadcrumbNames.deliveryZoneInfo
    );
    this.breadcrumbService.set(
      '@ap-charge-codes',
      breadcrumbNames.apChargeCode
    );
    this.breadcrumbService.set(
      '@ap-charge-code-information',
      breadcrumbNames.apChargeCodeInfo
    );
    this.breadcrumbService.set('@rate-scales', breadcrumbNames.RateScales);
    this.breadcrumbService.set(
      '@rate-scale-info',
      breadcrumbNames.RateScaleInfo
    );
    this.breadcrumbService.set(
      '@accounts-receivable-information',
      breadcrumbNames.accountsReceivableInvoiceInfo
    );
    this.breadcrumbService.set('@ap-information', breadcrumbNames.apInfo);
    this.breadcrumbService.set(
      '@currency-management',
      breadcrumbNames.currencyManagement
    );
    this.breadcrumbService.set('@routing', breadcrumbNames.Routing);
    this.breadcrumbService.set('@routing-summary', breadcrumbNames.Routing);
    this.breadcrumbService.set(
      '@routing-information',
      breadcrumbNames.RoutingInfo
    );
    this.breadcrumbService.set('@reports', breadcrumbNames.Reports);
    this.breadcrumbService.set(
      '@cancel-recover-shipments',
      breadcrumbNames.CancelRecoverShipments
    );
    this.breadcrumbService.set('@shortcut-keys', breadcrumbNames.ShortcutKeys
    );
  }
}
